module.exports = {
  apiUrl:'https://design.unirac.com',
  domainName : 'unirac.com',
  forgotPasswordLink:'https://services.unirac.com/forgotpassword'
};

  
